<template>
  <div>
    <vue-good-table mode="remote" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      :isLoading.sync="table.isLoading" :pagination-options="{
        enabled: false
      }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="'/contact/edit?id=' + props.row.id" @click.native="rememberPage">
            <a class="btn btn-primary text-white margin5">Edit</a>
          </router-link>
          <a v-if="hasFollowUpAddon" v-on:click="openAddToFlow(props.row)" class="btn btn-info text-white margin5" title="Tambah ke Follow Up">
            <i class="fas fa-sync-alt"></i>
          </a>
          <a v-on:click="deleteContact(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
        </span>
        <span v-else-if="props.column.field == 'labels'">
          <span v-for="l in (props.row._labels || [])" :key="l.id" class="ct-label-badge" :style="{ background: l.color, color: labelTextColor(l.color) }">{{ l.name }}</span>
          <span v-if="!props.row._labels || props.row._labels.length === 0" class="text-muted">-</span>
        </span>
        <span v-else-if="props.column.field == 'status'">
          <span v-if="props.row.status == 1">
            <span class="badge badge-success text-white">Valid</span>
          </span>
          <span v-else-if="props.row.status == 2">
            <span class="badge badge-danger text-white">Invalid</span>
          </span>
          <span v-else-if="!props.row.status">
            <span class="badge badge-warning text-white">Belum divalidasi</span>
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <div class="d-flex align-items-center justify-content-between mt-2">
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0">Per page</label>
        <select class="form-control form-control-sm w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
      <div class="d-flex align-items-center">
        <span class="text-muted small mr-3" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
        <div class="btn-group" role="group" aria-label="Pagination controls">
          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="cursorStack.length === 0 || table.isLoading"
            @click="goPrevPage"
            title="Go to previous page"
            aria-label="Previous">
            <i class="fas fa-chevron-left"></i>
            <span class="d-none d-sm-inline"> Previous</span>
          </button>
          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="!hasMore || table.isLoading"
            @click="goNextPage"
            title="Go to next page"
            aria-label="Next">
            <span class="d-none d-sm-inline">Next </span>
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
    <AddToFlowModal
      :visible="addToFlowVisible"
      :contact-id="selectedContactId"
      :contact-name="selectedContactName"
      :contact-number="selectedContactNumber"
      @close="addToFlowVisible = false"
    />
  </div>
</template>

<script>
  import AddToFlowModal from "@/components/forms/followup/AddToFlowModal.vue";

  export default {
    components: { AddToFlowModal },
    data() {
      return {
        addToFlowVisible: false,
        selectedContactId: null,
        selectedContactName: '',
        selectedContactNumber: '',
        table: {
          isLoading: true,
          columns: [{
              label: "Nama",
              field: "name",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "20%",
            },
            {
              label: "Nomor Whatsapp",
              field: "number",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "30%",
            },
            {
              label: "Tanggal Lahir",
              field: "birth_date",
              sortable: false,
              width: "20%",
              formatFn: (value) => {
                if (!value) return "-";
                const date = new Date(value);
                if (isNaN(date.getTime())) {
                  return value;
                }
                return date.toLocaleDateString("id-ID");
              },
            },
            {
              label: "Label",
              field: "labels",
              sortable: false,
              width: "18%",
              filterOptions: {
                enabled: true,
                placeholder: "Semua Label",
                filterDropdownItems: [],
              },
            },
            {
              label: "Status Whatsapp",
              field: "status",
              sortable: false,
              width: "18%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          allLabels: [],
          labelMaps: [],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            limit: 10,
            last_id: null,
          },
        },
        hasMore: false,
        cursorStack: [],
      };
    },
    computed: {
      hasFollowUpAddon() {
        return this.$store.state.auth.package?.follow_up == 1;
      }
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.restorePageState();
      this.loadItems();
      this.loadLabelData();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      labelTextColor(hex) {
        if (!hex || typeof hex !== 'string') return '#fff';
        const h = hex.replace('#', '').trim();
        if (h.length < 6) return '#fff';
        const r = parseInt(h.substr(0, 2), 16);
        const g = parseInt(h.substr(2, 2), 16);
        const b = parseInt(h.substr(4, 2), 16);
        const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return lum > 0.6 ? '#222' : '#fff';
      },
      openAddToFlow(row) {
        this.selectedContactId = row.id;
        this.selectedContactName = row.name || '';
        this.selectedContactNumber = row.number || '';
        this.addToFlowVisible = true;
      },
      // Simpan posisi halaman (cursor pagination) sebelum masuk Edit Kontak,
      // agar setelah klik "Kembali" / simpan, user balik ke halaman yang sama (bukan halaman 1).
      rememberPage() {
        try {
          sessionStorage.setItem('contactListState', JSON.stringify({
            last_id: this.table.serverParams.last_id,
            cursorStack: this.cursorStack,
            limit: this.table.serverParams.limit,
            columnFilters: this.table.serverParams.columnFilters || {},
          }));
        } catch (e) { /* ignore */ }
      },
      restorePageState() {
        try {
          const raw = sessionStorage.getItem('contactListState');
          if (!raw) return;
          sessionStorage.removeItem('contactListState'); // restore sekali saja
          const s = JSON.parse(raw);
          if (!s) return;
          this.cursorStack = Array.isArray(s.cursorStack) ? s.cursorStack : [];
          this.updateParams({
            last_id: s.last_id != null ? s.last_id : null,
            limit: s.limit || this.table.serverParams.limit,
            columnFilters: s.columnFilters || {},
          });
          // sinkronkan tampilan kotak filter dengan data yang difilter
          if (s.columnFilters) {
            this.table.columns.forEach(col => {
              if (col.filterOptions && s.columnFilters[col.field] !== undefined) {
                this.$set(col.filterOptions, 'filterValue', s.columnFilters[col.field]);
              }
            });
          }
        } catch (e) { /* ignore */ }
      },
      async deleteContact(id) {
        try {
          let response = await this.$store.dispatch("contact_delete", id);
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.$toast.error("Server error");
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onLimitChange() {
        this.updateParams({
          limit: this.table.serverParams.limit,
          last_id: null
        });
        this.cursorStack = [];
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
          last_id: null,
        });
        this.cursorStack = [];
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(Object.assign({}, params, { last_id: null }));
        this.cursorStack = [];
        this.loadItems();
      },
      goPrevPage() {
        if (this.cursorStack.length > 0) {
          const prevCursor = this.cursorStack.pop();
          this.updateParams({ last_id: prevCursor });
          this.loadItems();
        }
      },
      goNextPage() {
        if (this.hasMore) {
          this.cursorStack.push(this.table.serverParams.last_id);
          const rows = this.table.rows || [];
          const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
          this.updateParams({ last_id: nextCursor });
          this.loadItems();
        }
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          const contacts = response.data.data.contacts ?? [];
          this.table.rows = contacts;
          this.hasMore = Array.isArray(contacts) && contacts.length === this.table.serverParams.limit;
          this.mergeLabels();
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async loadLabelData() {
        try {
          const r = await this.$store.dispatch("contact_labels_list");
          this.table.allLabels = r.data.data.labels || [];
          this.populateLabelFilter();
          const r2 = await this.$store.dispatch("contact_labels_maps");
          this.table.labelMaps = r2.data.data.maps || [];
          this.mergeLabels();
        } catch (e) { /* silent */ }
      },
      populateLabelFilter() {
        // isi dropdown filter di kolom Label dengan daftar label milik user
        const col = this.table.columns.find(c => c.field === 'labels');
        if (col && col.filterOptions) {
          this.$set(col.filterOptions, 'filterDropdownItems',
            (this.table.allLabels || []).map(l => ({ value: String(l.id), text: l.name })));
        }
      },
      mergeLabels() {
        if (!this.table.labelMaps || !this.table.allLabels) return;
        const byContact = {};
        for (const m of this.table.labelMaps) {
          if (!byContact[m.contact_id]) byContact[m.contact_id] = [];
          const lbl = this.table.allLabels.find(l => l.id === m.label_id);
          if (lbl) byContact[m.contact_id].push(lbl);
        }
        this.table.rows = this.table.rows.map(r => ({ ...r, _labels: byContact[r.id] || [] }));
      },
      async getFromServer(param) {
        const payload = {
          limit: param.limit,
        };
        if (param.last_id) {
          payload.last_id = param.last_id;
        }
        if (param.columnFilters) {
          payload.columnFilters = param.columnFilters;
        }
        if (param.sort && param.sort.length && param.sort[0].field) {
          payload.sort = param.sort;
        }
        return await this.$store.dispatch("contact_list", payload);
      },
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
  .ct-label-badge {
    display: inline-block;
    color: #fff;
    padding: 2px 9px;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 500;
    margin: 2px 3px 2px 0;
    white-space: nowrap;
  }
</style>